import React from "react";
import DocumentViewer from "../DocumentViewer/DocumentViewer";
import "./DocumentModal.css";

type DocumentModalProps = {
  open: boolean;
  title: string;
  docUrl: string;
  onClose: () => void;
};

const DocumentModal: React.FC<DocumentModalProps> = ({
  open,
  title,
  docUrl,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="document-modal-overlay">
      <div className="document-modal">

        <div className="document-modal-header">
          <h2>{title}</h2>

          <button
            type="button"
            className="document-modal-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="document-modal-body">
          <DocumentViewer docUrl={docUrl} />
        </div>

      </div>
    </div>
  );
};

export default DocumentModal;

